import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import 'font-awesome-animation/css/font-awesome-animation.min.css'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(fas, far);

createApp(App).component("font-awesome-icon", FontAwesomeIcon).use(router).mount('#app')
